
import React, { useState } from "react";
import { DashboardShell } from "@/components/layout/DashboardShell";
import { DashboardOverview } from "@/components/dashboard/DashboardOverview";
import { DataInputForm } from "@/components/data-input/DataInputForm";
import { TenementsManager } from "@/components/tenements/TenementsManager";
import { JORCValuation } from "@/components/resource-valuation/JORCValuation";
import { ForecastModels } from "@/components/forecast/ForecastModels";
import { NPVCalculator } from "@/components/calculator/NPVCalculator";
import { SettingsForm } from "@/components/settings/SettingsForm";
import { CapitalManagement } from "@/components/capital/CapitalManagement";
import { ReportsGenerator } from "@/components/reports/ReportsGenerator";
import { AdminPanel } from "@/components/admin/AdminPanel";
import { BalanceSheet } from "@/components/balance-sheet/BalanceSheet";
import { FinancialAssumptionsForm } from "@/components/financial/FinancialAssumptionsForm";
import { AIFinancialDashboard } from "@/components/financial/AIFinancialDashboard";
import DataTables, { DataSource } from "@/components/data-tables/DataTables";

const Index = () => {
  console.log('Index component rendering');
  
  const [activePage, setActivePage] = useState("dashboard");
  const [selectedDataSource, setSelectedDataSource] = useState(null);

  // Handle viewing data tables from other components
  const handleViewDataTables = (dataSource: DataSource) => {
    setSelectedDataSource(dataSource);
    setActivePage("data-tables");
  };

  // Handle navigation to AI dashboard after model generation
  const handleNavigateToAIDashboard = () => {
    setActivePage("ai-dashboard");
  };

  const renderContent = () => {
    console.log('Index - rendering content for page:', activePage);
    
    switch (activePage) {
      case "dashboard":
        return <DashboardOverview onNavigateToAIDashboard={handleNavigateToAIDashboard} />;
      case "data-input":
        return <DataInputForm />;
      case "tenements":
        return <TenementsManager />;
      case "jorc-valuation":
      case "valuation":
        return <JORCValuation />;
      case "forecast":
        return <ForecastModels />;
      case "calculator":
        return <NPVCalculator />;
      case "capital":
        return <CapitalManagement />;
      case "reports":
        return <ReportsGenerator />;
      case "balance-sheet":
        return <BalanceSheet />;
      case "financial-assumptions":
      case "assumptions":
        return <FinancialAssumptionsForm />;
      case "ai-dashboard":
        return <AIFinancialDashboard />;
      case "admin":
        return <AdminPanel />;
      case "settings":
        return <SettingsForm />;
      case "data-tables":
        return <DataTables dataSource={selectedDataSource} onBack={() => setActivePage(selectedDataSource?.sourceType || "dashboard")} />;
      default:
        console.log('Index - falling back to dashboard for unknown page:', activePage);
        return <DashboardOverview onNavigateToAIDashboard={handleNavigateToAIDashboard} />;
    }
  };

  return (
    <DashboardShell activePage={activePage} onNavigate={setActivePage}>
      {renderContent()}
    </DashboardShell>
  );
};

export default Index;
